import {
  InventoryStockLocationRecord,
  InventoryStockLocationType,
  SaveInventoryStockLocationRequest,
} from '@/renderer/types/inventory';

export interface InventoryStockLocationFormState {
  name: string;
  type: InventoryStockLocationType;
  description: string;
  isActive: boolean;
}

export const INVENTORY_STOCK_LOCATION_TYPE_OPTIONS: Array<{
  value: InventoryStockLocationType;
  label: string;
}> = [
  { value: 'store', label: 'Store' },
  { value: 'kitchen', label: 'Kitchen' },
  { value: 'bar', label: 'Bar' },
  { value: 'pantry', label: 'Pantry' },
  { value: 'warehouse', label: 'Warehouse' },
  { value: 'production', label: 'Production' },
];

export const createEmptyInventoryStockLocationForm =
  (): InventoryStockLocationFormState => ({
    name: '',
    type: 'store',
    description: '',
    isActive: true,
  });

export const createInventoryStockLocationFormFromRecord = (
  record: InventoryStockLocationRecord,
): InventoryStockLocationFormState => ({
  name: record.name,
  type: record.type,
  description: record.description ?? '',
  isActive: record.is_active,
});

export const buildSaveInventoryStockLocationPayload = (
  companyId: number,
  outletId: string,
  form: InventoryStockLocationFormState,
  id?: string,
): SaveInventoryStockLocationRequest => ({
  id,
  companyId,
  outletId,
  name: form.name,
  type: form.type,
  description: form.description || null,
  isActive: form.isActive,
});
